import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

const fetchTestCase = async (id, searchTerm) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios.get(`${API_BASE_PATH}${API_BASE_RELATIVE_PATH}`, {
    params: {
      action: "searchTCSearch",
      companyid: user.companyid,
      modid: id,
      key: searchTerm,
    },
  });

  return response.data;
};

const useTestCaseQuery = (id, searchTerm, options) => {
  return useQuery({
    queryKey: ["searchTCSearch", id, searchTerm],
    queryFn: () => fetchTestCase(id, searchTerm),
    enabled: options.enabled && id !== "" && id !== null,
    retry: true,
    // cacheTime: 90000,
    // refetchInterval: false,
    // refetchIntervalInBackground: false,
    // staleTime: Infinity,
  });
};

export default useTestCaseQuery;
